<template>
	<v-dialog v-model="isDialogOpen" :max-width="600" transition="dialog-transition" content-class="app-dialog add-users-dialog">
		<div class="display-flex flex-column align-center">
			<div class="dialog-title">Select users for this group</div>
			<template>
				<v-data-table v-model="selected" :headers="headers" :items="members" item-key="id" show-select class="elevation-1" />
			</template>
			<SecondaryButton class="mt-2" @click="addUsers">Add to group</SecondaryButton>
		</div>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { teamMembers } from '@/store/modules/account/getters';
import { user } from '@/store/modules/auth/getters';
import { getAccountMembers } from '@/store/modules/account/actions';
import { setGroupUsers } from '@/store/modules/accountGroups/actions';
import { selectedGroup } from '@/store/modules/accountGroups/getters';
import { INACTIVE, userStatus, userStatusToString } from '../../../Settings/user.const';

export default {
	name: 'AddUserDialog',
	components: {},
	props: {
		group: { type: Object },
		isShowDialog: { type: Boolean },
	},

	watch: {
		isShowDialog: {
			handler(isOpen) {
				this.isDialogOpen = isOpen;
			},
		},
		isDialogOpen: {
			handler(isOpen) {
				this.$emit('update:isShowDialog', isOpen);
			},
		},
	},
	computed: {
		...mapGetters([teamMembers.fullPath, user.fullPath, selectedGroup.fullPath]),
		members() {
			return this[teamMembers.fullPath].filter((u) => !this.isInactive(u)).map((u) => ({ ...u, statusText: userStatusToString[u.status] }));
		},
	},
	methods: {
		...mapActions([setGroupUsers.fullPath, getAccountMembers.fullPath]),
		addUsers() {
			const payload = {
				id: this.group.id,
				users: this.selected.map((x) => x.user_id),
			};
			this[setGroupUsers.fullPath](payload);
			this.isDialogOpen = false;
		},
		isInactive(u) {
			return u.status === userStatus[INACTIVE];
		},
	},
	async mounted() {
		await this[getAccountMembers.fullPath]();
		this.selected = this.members.filter((u) => this[selectedGroup.fullPath].users.includes(u.user_id));
	},
	data: () => ({
		isDialogOpen: false,
		selected: [],
		headers: [
			{
				text: 'Name',
				align: 'start',
				sortable: false,
				value: 'name',
			},
			{ text: 'Email', value: 'email' },
			{ text: 'Status', value: 'statusText' },
		],
	}),
};
</script>

<style scoped lang="scss">
.add-users-dialog {
	> div {
		padding: 0 20px 20px 20px;
	}

	.dialog-title {
		text-align: center;
		font-weight: 500;
	}
}
</style>
